import React, { Component } from "react";
import { observer } from "mobx-react";
import store from "./store";
import ReviewList from "./shared/ReviewList";

@observer
class App extends Component {
  currentPage = 0;
  surveyUid = process.env.REACT_APP_WEBSITE_UID;
  surveyUrl = "";

  constructor(props) {
    super();
    if (props.surveyUid) {
      this.surveyUid = props.surveyUid;
    }
    this.surveyUrl = `${process.env.REACT_APP_API_HOST}/${this.surveyUid}`;
    this.loc_city = props.city || "";
    this.loc_state = props.state || "";
  }

  getReviews() {
    this.currentPage = this.currentPage + 1;
    store.getReviews(this.props.merchant, this.currentPage, this.loc_city, this.loc_state);
  }

  componentDidMount() {
    this.getReviews();
  }

  surveyUid() {
    if (this.props.surveyUid) {
      return this.props.surveyUid;
    } else {
      return process.env.REACT_APP_WEBSITE_UID;
    }
  }

  render() {
    const { sortedReviews } = store;

    let fromFB = document.referrer.match(/facebook/);
    return (
      <div id="review-list-container" style={{ marginTop: "2em" }}>
        <ReviewList
          reviews={sortedReviews}
          getReviews={this.getReviews.bind(this)}
          showLocation={!!(this.loc_city && this.loc_state)}
          merchant={store.merchant}
        />
        {!fromFB && (
          <a className="bottom-btn write-review" href={this.surveyUrl}>
            Want to share your success story?&nbsp;
            <strong>Add a Hibu review here.</strong>
          </a>
        )}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js